import { DepositHistoryResponse, TransactionHistoryResponse, WithdrawalHistoryResponse } from '@shared/api';

export const isDepositHistoryArray = (e: Array<TransactionHistoryResponse>): e is Array<DepositHistoryResponse> =>
  (e as Array<DepositHistoryResponse>)?.[0]?.depositId !== undefined;

export const isWithdrawalHistoryArray = (e: Array<TransactionHistoryResponse>): e is Array<WithdrawalHistoryResponse> =>
  (e as Array<WithdrawalHistoryResponse>)?.[0]?.withdrawalId !== undefined;
